// Interface base para provedores de WhatsApp
export class WhatsAppProviderBase {
    constructor(config) {
      this.config = config;
    }
    
    // Método obrigatório para enviar mensagem
    async send(payload) {
      throw new Error('Método send não implementado');
    }
    
    // Método obrigatório para enviar template
    async sendTemplate(template, params, to) {
      throw new Error('Método sendTemplate não implementado');
    }
  }